{
  "version": 1,
  "asset_id": "132c8c5a-98cb-414f-b40d-57e5025f0190",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/132c8c5a-98cb-414f-b40d-57e5025f0190/bypass-revision-oversized-pouch-es-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/132c8c5a-98cb-414f-b40d-57e5025f0190/bypass-revision-oversized-pouch-es-640.webp",
  "original_filename": "bypass-revision-oversized-pouch-es-640.webp",
  "size": 36124,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:19Z"
}
